<template lang="pug">
div
  .teams-promotion-banner
  .teams
    //- FIXME: For now the upsell banner won't be shown until we address and improve
    //- the feature checks and the pattern for upsell banners a little bit more. This
    //- won't be shown because of the getter `showTeamsUI`; for more check: `MembersStore/getters.js#109`
    div(v-if="!teamsFeatureEnabled && !showDialogLoading")
      AppUpsellBanner(
        :feature="teamsFeature"
        :organization-id="organizationId"
        :can-manage-billing="canManageBilling"
      )
    div(v-else)
      ValidationProvider(
        v-slot="{ errors }"
        name="teams"
      )
        .form-group(:class="{ 'has-error': errors[0] }")
          label.control-label Teams
          a.pull-right.select-all(
            v-if="teamsOptions.length"
            @click="selectAll"
          )
            | Select all
          AppSelect(
            v-model="selectedTeams"
            :options="contextAwareTeamsOptions"
            :select2-options="select2Options"
            :prevent-clear-ids="selectedScimManagedTeamIds"
          )
          AppDialogError(:errors="errors")
      a(
        v-if="teamsPromotionEnabled"
        href="https://support.hubstaff.com/teams-overview/#create"
        target="_blank"
        rel="noopener noreferrer"
      )
        | Learn more about Teams
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';

export default {
  name: 'MemberDialogTabTeams',
  data() {
    return {
      defaultSelect2Options: {
        allowClear: true,
        multiple: true,
        width: '100%',
      },
    };
  },
  computed: {
    ...mapState({
      organizationId: (state) => state.organization.id,
      selectedTeams: (state) => state.membership.team_ids,
      teamsPromotionEnabled: (state) => state.current_user.teams_promotion_enabled,
    }),
    ...mapGetters(['canManageBilling', 'teamsFeatureEnabled', 'teamsOptions', 'teamsFeature', 'showDialogLoading']),
    selectedTeams: {
      get() {
        return this.$store.state.membership.team_ids;
      },
      set(value) {
        const currentTeams = this.$store.state.membership.team_ids || [];
        const scimTeamsToKeep = currentTeams.filter(id => {
          const option = this.teamsOptions.find(opt => opt.id === id);

          return option && option.scimManaged;
        });
        const finalTeams = [...new Set([...value, ...scimTeamsToKeep])];

        this.updateTeams(finalTeams);
      },
    },
    select2Options() {
      return {
        ...this.defaultSelect2Options,
        ...{
          placeholder: 'Select teams',
        },
      };
    },
    selectedScimManagedTeamIds() {
      const originalTeams = this.$store.state.membership.team_ids || [];

      return originalTeams.filter((id) => {
        const opt = this.teamsOptions.find((o) => o.id === id);

        return opt && opt.scimManaged;
      });
    },
    contextAwareTeamsOptions() {
      const selectedTeamIds = new Set(this.$store.state.membership.team_ids || []);

      return this.teamsOptions.map(team => {
        let disabled = team.disabled;
        let disabledHint = team.disabledHint;

        if (team.scimManaged) {
          const isCurrentlySelected = selectedTeamIds.has(team.id);

          if (isCurrentlySelected) {
            disabled = true;
            disabledHint = 'Team managed by SCIM';
          }
        }

        return { ...team, disabled, disabledHint };
      });
    },
  },
  methods: {
    ...mapActions(['updateTeams']),
    selectAll() {
      const val = this.contextAwareTeamsOptions.filter((t) => !t.disabled).map(({ id }) => id);
      const scimTeamsToKeep = this.selectedScimManagedTeamIds;
      const finalTeams = [...new Set([...val, ...scimTeamsToKeep])];

      this.updateTeams(finalTeams);
    },
  },
};
</script>
